import type { AvailabilityAccommodationSet } from "@/types/api/availabilities";
import type {
  RateOptionAccommodationHotel,
  RateOptionAccommodationSet,
} from "@/types/api/group-tour-details";
import { getOrdinalSuffix } from "@/lib/utils";

export function formatHotelNights(nights: number[]): string {
  if (!nights.length) return "";
  const ordinals = nights.map((n) => `${n}${getOrdinalSuffix(n)}`);
  if (ordinals.length === 1) {
    return `${ordinals[0]} night`;
  }

  if (ordinals.length === 2) {
    return `${ordinals[0]} and ${ordinals[1]} night`;
  }

  return `${ordinals.slice(0, -1).join(", ")}, and ${ordinals.at(-1)} night`;
}

export function formatHotelDetails(
  hotel: RateOptionAccommodationHotel
): string {
  const nightsLabel = formatHotelNights(hotel.nights);
  const details = [hotel.room_type, nightsLabel].filter(Boolean).join(" · ");
  return details ? `${hotel.name} (${details})` : hotel.name;
}

export function normalizeAccommodationSet(
  set?: AvailabilityAccommodationSet | null
): RateOptionAccommodationSet | undefined {
  if (!set) {
    return undefined;
  }

  return {
    id: set.id,
    name: set.name,
    hotels: set.hotels.map((hotel) => ({
      id: hotel.id,
      name: hotel.name,
      room_type: hotel.room_type,
      nights: hotel.nights ?? [],
    })),
  };
}
